import React, {createRef, useEffect, useState} from "react";
import {changeSurveyId, changeSurveyTitle} from "../../../../slices/surveyEditorSlice";
import SurveysService from "../../../../services/SurveysService";
import {useDispatch, connect} from "react-redux";
import {withRouter} from "react-router-dom";
import * as BubblyUIUtils from "../../../../utils/BubblyUIUtils";

function TitleBox(props) {
    const dispatch = useDispatch();
    const {surveyTitle} = props;
    const surveyId = props.match.params.surveyId;
    const titleInput = createRef();

    const [isTitleInEdit, setIsTitleInEdit] = useState(false);

    useEffect(() => {
        const titleStyle = getComputedStyle(titleInput.current);
        const newTitleWidth = BubblyUIUtils.getTextPixelWidth(surveyTitle, titleStyle.fontFamily, titleStyle.fontWeight, titleStyle.fontSize);
        titleInput.current.style.width = newTitleWidth;
    }, [surveyTitle]);

    const onTitleEditClick = () => {
        if (! isTitleInEdit) {
            setIsTitleInEdit(true);
            titleInput.current.focus();
        }
    };

    const onTitleChange = (e) => {
        dispatch(changeSurveyTitle(e.target.value));
    };

    const onKeyPress = (e) => {
        e.key === "Enter" && e.target.blur();
    };

    const onTitleEditOver = (e) => {
        setIsTitleInEdit(false);

        let surveyTitle = e.target.value;
        if (! surveyTitle) {
            surveyTitle = 'Untitled survey';
            dispatch(changeSurveyTitle(surveyTitle));
        }

        SurveysService.postSurveyTitle(surveyId, surveyTitle, (res) => {
            const resSurveyId = res.data;
            dispatch(changeSurveyId(resSurveyId));
            props.history.push('/survey/builder/' + resSurveyId);
        });
    };

    return (
        <h1 className="questionaire__builder__title questionaire__builder__title--action pb-md pt-xl">
            <input className="questionaire__builder__title questionaire__builder__title--action" type="text"
                   value={surveyTitle}
                   ref={titleInput}
                   onClick={onTitleEditClick}
                   onChange={onTitleChange}
                   onKeyPress={onKeyPress}
                   onBlur={onTitleEditOver}
                   maxLength={100} />
            <a href="#" className="questionaire__builder__title__edit"
               onClick={(event) => {event.preventDefault();onTitleEditClick();}}
               onMouseOver={() => {titleInput.current.classList.add("input_hover")}}
               onMouseOut={() => {titleInput.current.classList.remove("input_hover")}} />
        </h1>
    );
}

function mapStateToProps(state) {
    const {survey} = state;
    return {
        surveyTitle: survey.title
    };
}

export default withRouter(connect(mapStateToProps)(TitleBox));